import { render } from "./submitCourse.vue?vue&type=template&id=2a5cb906&scoped=true"
import script from "./submitCourse.vue?vue&type=script&lang=js"
export * from "./submitCourse.vue?vue&type=script&lang=js"

import "./submitCourse.vue?vue&type=style&index=0&id=2a5cb906&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5cb906"]])

export default __exports__